import { render, staticRenderFns } from "./ApplicantTypeWizard.vue?vue&type=template&id=25db40a8&scoped=true&"
import script from "./ApplicantTypeWizard.vue?vue&type=script&lang=js&"
export * from "./ApplicantTypeWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db40a8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VCardTitle,VIcon,VRadio,VRadioGroup,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25db40a8')) {
      api.createRecord('25db40a8', component.options)
    } else {
      api.reload('25db40a8', component.options)
    }
    module.hot.accept("./ApplicantTypeWizard.vue?vue&type=template&id=25db40a8&scoped=true&", function () {
      api.rerender('25db40a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Application/Setup/ApplicantTypeWizard.vue"
export default component.exports